/**
 * Keeps the overlay (viewport-fixed) header below the announcement bar. The
 * bar lives in normal flow above the header group, so the fixed header would
 * otherwise paint over it at top:0. Tracking the bar's visible bottom edge —
 * rather than a one-time height — lets the header slide up to the viewport
 * top as the bar scrolls away, with no gap left behind. No-op on solid-header
 * pages (header in flow, already below the bar) or when the merchant removes
 * the announcement section.
 */
const nav = document.querySelector('.mtn-nav.is-overlay');
const bar = document.querySelector('.announcement-bar');

if (nav && bar) {
  const update = () => {
    const bottom = Math.max(0, bar.getBoundingClientRect().bottom);
    nav.style.setProperty('--mtn-header-offset', `${bottom}px`);
  };
  // Batch the layout read + style write behind one rAF per frame instead of
  // running in every scroll event (stock header.js's #handleWindowScroll
  // guard pattern, ticket 27).
  let scrollRafId = null;
  const requestUpdate = () => {
    if (scrollRafId !== null) return;
    scrollRafId = requestAnimationFrame(() => {
      scrollRafId = null;
      update();
    });
  };
  update();
  // Capture-phase: at desktop the theme scrolls .page-wrapper (html/body are
  // overflow:hidden), and inner scrolls never reach window. Capture on
  // document hears both that and regular document scrolling.
  document.addEventListener('scroll', requestUpdate, { capture: true, passive: true });
  window.addEventListener('resize', requestUpdate);
}
